export default {
  scroll: 'Scroll',
  discover: 'Scopri',
  view: 'Vedi',
  read: 'Leggi',
  download: 'Download',
}
